(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('[data-collection-filters]');
    if (!root) return;

    const overlay = root.querySelector('[data-collection-filters-overlay]');
    let lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        root.classList.add('collection-filters--open');
      });
      document.documentElement.style.overflow = 'hidden';
      const toggle = document.querySelector('[data-collection-filter-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      const closeBtn = root.querySelector('[data-collection-filters-close]');
      if (closeBtn) closeBtn.focus();
      
      // Initialize applied filters preview on open
      updateAppliedFiltersPreview();
    }

    function close() {
      root.classList.remove('collection-filters--open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      const toggle = document.querySelector('[data-collection-filter-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      setTimeout(function () {
        root.hidden = true;
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }, 300);
    }

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-collection-filter-open]');
      if (trigger) {
        e.preventDefault();
        open();
        return;
      }

      if (!root.classList.contains('collection-filters--open')) return;

      const closeTrigger = e.target.closest('[data-collection-filters-close]');
      if (closeTrigger) {
        e.preventDefault();
        close();
        return;
      }

      if (e.target === overlay) {
        close();
      }
    });

    // Toggle applied filters visibility and update list if checkboxes are changed
    root.addEventListener('change', function() {
      updateAppliedFiltersPreview();
      updateResultsCount();
    });

    async function updateResultsCount() {
      const countEl = root.querySelector('[data-results-count]');
      if (!countEl) return;

      const formData = new FormData(root.querySelector('form'));
      const searchParams = new URLSearchParams(formData).toString();
      const url = `${window.location.pathname}?${searchParams}`;

      try {
        const response = await fetch(url);
        if (!response.ok) return;
        
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCountEl = doc.querySelector('[data-results-count]');
        
        if (newCountEl) {
          countEl.textContent = newCountEl.textContent;
        }
      } catch (e) {
        console.error('Failed to update results count', e);
      }
    }

    function updateAppliedFiltersPreview() {
      const container = root.querySelector('[data-applied-filters]');
      if (!container) return;

      const list = container.querySelector('.applied-filters__list');
      if (!list) return;

      const selectedInputs = Array.from(root.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked:not([name="sort_by"])'));
      const priceInputs = Array.from(root.querySelectorAll('.collection-filters__price-input'));
      
      let html = '';

      // Add chips for checkboxes/radios
      selectedInputs.forEach(input => {
        const labelEl = input.closest('label');
        let label = '';
        if (labelEl) {
          const checkLabel = labelEl.querySelector('.collection-filters__check-label');
          const swatchName = labelEl.querySelector('.collection-filters__swatch-name');
          const sizeText = labelEl.querySelector('.collection-filters__size-text');
          label = (checkLabel || swatchName || sizeText || labelEl).textContent.split('(')[0].trim();
        }

        if (!label) label = input.value;

        html += `
          <li>
            <button
              type="button"
              class="collection-filters__active-chip inline-flex items-center gap-2 border border-[#141414] p-3 bg-white text-xs tracking-wider"
              data-remove-preview-filter
              data-input-id="${input.id || ''}"
              data-input-name="${input.name}"
              data-input-value="${input.value.replace(/"/g, '&quot;')}"
            >
              <span>${label}</span>
              <span class="collection-filters__chip-x" aria-hidden="true">${root.querySelector('.collection-filters__close svg').outerHTML}</span>
            </button>
          </li>
        `;
      });

      // Add chips for price ranges
      const minInput = root.querySelector('input[name="filter.v.price.gte"]');
      const maxInput = root.querySelector('input[name="filter.v.price.lte"]');
      if ((minInput && minInput.value) || (maxInput && maxInput.value)) {
        const symbol = container.dataset.currencySymbol || '';
        const min = minInput && minInput.value ? symbol + minInput.value : symbol + '0';
        const max = maxInput && maxInput.value ? symbol + maxInput.value : '';
        const label = max ? `${min} – ${max}` : `${min}+`;
        
        html += `
          <li>
            <button
              type="button"
              class="collection-filters__active-chip inline-flex items-center gap-2 border border-[#141414] px-3 h-8 text-xs uppercase tracking-wider"
              data-remove-price-preview
            >
              <span>${label}</span>
              <span class="collection-filters__chip-x" aria-hidden="true">${root.querySelector('.collection-filters__close svg').outerHTML}</span>
            </button>
          </li>
        `;
      }

      list.innerHTML = html;

      if (html === '') {
        container.classList.add('hidden');
      } else {
        container.classList.remove('hidden');
      }
    }

    // Handle removing filters from the preview
    root.addEventListener('click', function(e) {
      const removeBtn = e.target.closest('[data-remove-preview-filter]');
      if (removeBtn) {
        const name = removeBtn.dataset.inputName;
        const value = removeBtn.dataset.inputValue;
        const input = root.querySelector(`input[name="${name}"][value="${value}"]`);
        if (input) {
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      const removePriceBtn = e.target.closest('[data-remove-price-preview]');
      if (removePriceBtn) {
        const minInput = root.querySelector('input[name="filter.v.price.gte"]');
        const maxInput = root.querySelector('input[name="filter.v.price.lte"]');
        if (minInput) minInput.value = '';
        if (maxInput) maxInput.value = '';
        if (minInput) minInput.dispatchEvent(new Event('change', { bubbles: true }));
        else if (maxInput) maxInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('collection-filters--open')) {
        close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-filters"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('[data-search-filters]');
    if (!root) return;

    const overlay = root.querySelector('[data-search-filters-overlay]');
    let lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        root.classList.add('collection-filters--open');
      });
      document.documentElement.style.overflow = 'hidden';
      const toggle = document.querySelector('[data-search-filter-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      const closeBtn = root.querySelector('[data-search-filters-close]');
      if (closeBtn) closeBtn.focus();
      
      // Initialize applied filters preview on open
      updateAppliedFiltersPreview();
    }

    function close() {
      root.classList.remove('collection-filters--open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      const toggle = document.querySelector('[data-search-filter-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      setTimeout(function () {
        root.hidden = true;
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }, 300);
    }

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-search-filter-open]');
      if (trigger) {
        e.preventDefault();
        open();
        return;
      }

      if (!root.classList.contains('collection-filters--open')) return;

      const closeTrigger = e.target.closest('[data-search-filters-close]');
      if (closeTrigger) {
        e.preventDefault();
        close();
        return;
      }

      if (e.target === overlay) {
        close();
      }
    });

    // Toggle applied filters visibility and update list if checkboxes are changed
    root.addEventListener('change', function() {
      updateAppliedFiltersPreview();
      updateResultsCount();
    });

    async function updateResultsCount() {
      const countEl = root.querySelector('[data-results-count]');
      if (!countEl) return;

      const formData = new FormData(root.querySelector('form'));
      const searchParams = new URLSearchParams(formData).toString();
      const url = `${window.location.pathname}?${searchParams}`;

      try {
        const response = await fetch(url);
        if (!response.ok) return;
        
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCountEl = doc.querySelector('[data-results-count]');
        
        if (newCountEl) {
          countEl.textContent = newCountEl.textContent;
        }
      } catch (e) {
        console.error('Failed to update results count', e);
      }
    }

    function updateAppliedFiltersPreview() {
      const container = root.querySelector('[data-applied-filters]');
      if (!container) return;

      const list = container.querySelector('.applied-filters__list');
      if (!list) return;

      const selectedInputs = Array.from(root.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked:not([name="sort_by"])'));
      const priceInputs = Array.from(root.querySelectorAll('.collection-filters__price-input'));
      
      let html = '';

      // Add chips for checkboxes/radios
      selectedInputs.forEach(input => {
        const labelEl = input.closest('label');
        let label = '';
        if (labelEl) {
          const checkLabel = labelEl.querySelector('.collection-filters__check-label');
          const swatchName = labelEl.querySelector('.collection-filters__swatch-name');
          const sizeText = labelEl.querySelector('.collection-filters__size-text');
          label = (checkLabel || swatchName || sizeText || labelEl).textContent.split('(')[0].trim();
        }

        if (!label) label = input.value;

        html += `
          <li>
            <button
              type="button"
              class="collection-filters__active-chip inline-flex items-center gap-2 border border-[#141414] p-3 bg-white text-xs tracking-wider"
              data-remove-preview-filter
              data-input-id="${input.id || ''}"
              data-input-name="${input.name}"
              data-input-value="${input.value.replace(/"/g, '&quot;')}"
            >
              <span>${label}</span>
              <span class="collection-filters__chip-x" aria-hidden="true">${root.querySelector('.collection-filters__close svg').outerHTML}</span>
            </button>
          </li>
        `;
      });

      // Add chips for price ranges
      const minInput = root.querySelector('input[name="filter.v.price.gte"]');
      const maxInput = root.querySelector('input[name="filter.v.price.lte"]');
      if ((minInput && minInput.value) || (maxInput && maxInput.value)) {
        const symbol = container.dataset.currencySymbol || '';
        const min = minInput && minInput.value ? symbol + minInput.value : symbol + '0';
        const max = maxInput && maxInput.value ? symbol + maxInput.value : '';
        const label = max ? `${min} – ${max}` : `${min}+`;
        
        html += `
          <li>
            <button
              type="button"
              class="collection-filters__active-chip inline-flex items-center gap-2 border border-[#141414] px-3 h-8 text-xs uppercase tracking-wider"
              data-remove-price-preview
            >
              <span>${label}</span>
              <span class="collection-filters__chip-x" aria-hidden="true">${root.querySelector('.collection-filters__close svg').outerHTML}</span>
            </button>
          </li>
        `;
      }

      list.innerHTML = html;

      if (html === '') {
        container.classList.add('hidden');
      } else {
        container.classList.remove('hidden');
      }
    }

    // Handle removing filters from the preview
    root.addEventListener('click', function(e) {
      const removeBtn = e.target.closest('[data-remove-preview-filter]');
      if (removeBtn) {
        const name = removeBtn.dataset.inputName;
        const value = removeBtn.dataset.inputValue;
        const input = root.querySelector(`input[name="${name}"][value="${value}"]`);
        if (input) {
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      const removePriceBtn = e.target.closest('[data-remove-price-preview]');
      if (removePriceBtn) {
        const minInput = root.querySelector('input[name="filter.v.price.gte"]');
        const maxInput = root.querySelector('input[name="filter.v.price.lte"]');
        if (minInput) minInput.value = '';
        if (maxInput) maxInput.value = '';
        if (minInput) minInput.dispatchEvent(new Event('change', { bubbles: true }));
        else if (maxInput) maxInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('collection-filters--open')) {
        close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
